import { apiClient } from './client'
import type { FeedPage } from './types'

export const fetchMyFeed = async (page: number, size: number): Promise<FeedPage> => {
  const response = await apiClient.get<FeedPage>('/api/v1/me/feed', {
    params: { page, size },
  })
  return response.data
}
